import { PaymentMethod } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
export const SessionPaymentType = {
    DEPOSIT: 'DEPOSIT',
    FULL: 'FULL',
};
export const billingAddressSchema = z.object({
    city: z.string().min(1),
    countryCode: z.string().min(1),
    street: z.string().min(1),
    zipCode: z.string().min(1),
});
/**
 * FLOA (INSTALLMENTS) checkout requires a billing address and a FLOA pay type.
 * Mirrors the legacy `@IsDefined @ValidateIf(o => o.paymentMethod === INSTALLMENTS)`
 * via a flat object + superRefine (downstream service reads fields off a flat dto).
 */
export const initiateSessionCheckoutSchema = z
    .object({
    buyerEmail: z.string().optional(),
    billingAddress: billingAddressSchema.optional(),
    buyerPhone: z.string().optional(),
    depositAmount: z.number().min(0).optional(),
    floaPayType: z.enum(['3XG', '4XG']).optional(),
    paymentMethod: z.nativeEnum(PaymentMethod),
    paymentType: z.nativeEnum(SessionPaymentType),
    subscribeToNotifications: z.boolean().optional(),
})
    .superRefine((data, ctx) => {
    if (data.paymentMethod === PaymentMethod.INSTALLMENTS) {
        if (!data.billingAddress) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "L'adresse de facturation est requise pour le paiement FLOA.",
                path: ['billingAddress'],
            });
        }
        if (!data.floaPayType) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Le type de paiement FLOA (3x ou 4x) est requis.',
                path: ['floaPayType'],
            });
        }
    }
});
